import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

export interface WizardProgressProps {
  steps: string[]
  currentStep?: number
  defaultStep?: number
  onStepChange?: (index: number) => void
}

export const WizardProgress = ({
  steps,
  currentStep,
  defaultStep,
  onStepChange,
}: WizardProgressProps) => {
  const tabCls = /*tw*/ `
    px-2
    py-1
    rounded-b
    border-t-2
    text-start
    data-[state=active]:text-foreground
    data-[state=active]:border-brand-secondary-700
    data-[state=active]:bg-brand-secondary-100
    data-[state=inactive]:text-muted-foreground
    data-[state=inactive]:border-border
  `

  return (
    <TabsPrimitive.Root
      orientation="horizontal"
      defaultValue={defaultStep?.toString()}
      value={currentStep?.toString()}
      onValueChange={(value) => onStepChange?.(parseInt(value))}
      activationMode="manual"
    >
      <TabsPrimitive.List className="flex gap-2">
        {steps.map((step, index) => (
          <TabsPrimitive.Trigger
            key={index}
            value={index.toString()}
            className={cn(tabCls, "flex-grow basis-0 text-body1", {
              "cursor-pointer": onStepChange,
              "cursor-default": !onStepChange,
            })}
            disabled={!onStepChange}
          >
            {step}
          </TabsPrimitive.Trigger>
        ))}
      </TabsPrimitive.List>
    </TabsPrimitive.Root>
  )
}
